import React from 'react';

function Footer() {   
    return (
    <div class="footer" id="footer">
        <a href="https://github.com/roxyvaught"><img src="https://img.icons8.com/color/48/000000/github--v1.png" alt="Github" class="icon"/></a>
        <a href="https://www.linkedin.com/in/roxannavaught/"><img src="https://img.icons8.com/color/48/000000/linkedin.png" alt="LinkedIn" class="icon"/></a>
        <a href="https://github.com/roxyvaught/react-portfolio/raw/master/src/assets/resume.pdf" class="link"><img src="https://img.icons8.com/ultraviolet/40/000000/open-resume.png" alt="resume" class="icon"/></a>
        <a href="mailto:roxanna.vaught@gmail.com"><img src="https://img.icons8.com/ultraviolet/40/000000/email-open.png"  alt="email" class="icon"/></a>
        <p>
        &copy; Roxanna Vaught-Mijares  |  <a href="https://github.com/roxyvaught/react-portfolio/raw/master/src/assets/resume.pdf" class="link">Download My Resume</a> 
        </p>

    </div>
    )
}

export default Footer;